/* The photograph behind the login screen, and a different one every week.

   Max, 2026-10-06: "tôi gửi bảng 1 folder ảnh luôn và tôi muốn nó thay đổi theo ngày á". Nine
   Helinox lifestyle shots, resized to 2560px and saved at quality 62 — around 480KB each, and
   only ONE is ever fetched, because the others are never referenced by the page that renders.
   The originals are 5472x3648 and 11-21MB; a login screen that costs 15MB to look at is a login
   screen people wait for.

   THE WEEK DECIDES, NOT THE DAY, AND NOT CHANCE. It was daily until Jay Jung said why that is
   wrong, 2026-10-07: "not every day. People confused whether they are in wrong website." A login
   screen is the one page people are checking they have arrived at the right place, and a picture
   that is different every morning quietly undermines that — it is the one piece of the page that
   should feel settled. Weekly it still changes and is still noticed; it just stops being the
   thing somebody has to think about before typing a password.

   A random pick is worse again: it changes on every reload, which reads as a page that cannot
   make up its mind and makes "the one with the lake" impossible to refer to.

   Whole weeks since the epoch, +3 so the boundary falls on a MONDAY — 1970-01-01 was a Thursday,
   and a picture that turns over mid-week would land on somebody's Wednesday for no reason.

   Date.UTC on the local Y/M/D rather than getTime(): the second is a moment and would put Hanoi
   and Seoul on different pictures for seven hours of every day. The first is a calendar day. */

import fallMtHoward123 from './login-bg/fall-mt-howard-123.jpg';
import fallMtHoward126 from './login-bg/fall-mt-howard-126.jpg';
import fallSunset117 from './login-bg/fall-sunset-chair-117.jpg';
import fallSunset135 from './login-bg/fall-sunset-chair-135.jpg';
import springZero134 from './login-bg/spring-chair-zero-134.jpg';
import springZero58 from './login-bg/spring-chair-zero-58.jpg';
import springZero66 from './login-bg/spring-chair-zero-66.jpg';
import summerBeach10 from './login-bg/summer-beach-chair-10.jpg';
import summerBeach50 from './login-bg/summer-beach-chair-50.jpg';

/* Ordered so consecutive days do not land in the same shoot — four of the nine come in pairs from
   one session, and two days running of the same riverbank would read as the picture being stuck. */
export const LOGIN_BACKGROUNDS = [
    fallMtHoward123,
    springZero58,
    summerBeach10,
    fallSunset117,
    springZero134,
    summerBeach50,
    fallMtHoward126,
    springZero66,
    fallSunset135,
];

export const backgroundForThisWeek = (now = new Date()) => {
    const day = Math.floor(
        Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000,
    );
    const week = Math.floor((day + 3) / 7);
    return LOGIN_BACKGROUNDS[((week % LOGIN_BACKGROUNDS.length) + LOGIN_BACKGROUNDS.length)
        % LOGIN_BACKGROUNDS.length];
};
